import { Box, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTheme } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import useFilterDropdownStyles from "../SharedStyles/useFilterDropdownStyles";

export function UsersFilter({ onFiltered, initialUsers }) {
  const [users, setUsers] = useState([]);
  const [selecteds, setSelecteds] = useState([]);
  const theme = useTheme();
  const isDark = theme.mode === "dark" || theme.palette.type === "dark";
  const dropdownClasses = useFilterDropdownStyles();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/users/list`);
        setUsers(data.map((u) => ({ id: u.id, name: u.name })));
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    setSelecteds([]);
    if (Array.isArray(initialUsers) && Array.isArray(users) && users.length > 0) {
      onChange(initialUsers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialUsers, users]);

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  const summaryText =
    selecteds.length === 0
      ? ""
      : selecteds.length === 1
      ? selecteds[0].name
      : `${selecteds.length} ${i18n.t("statusFilter.selected") || "selecionados"}`;

  return (
    <Box style={{ padding: 10 }}>
      <Autocomplete
        multiple
        size="small"
        options={users}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(o) => o.name}
        getOptionSelected={(o, v) => o?.id === v?.id || o?.name?.toLowerCase() === v?.name?.toLowerCase()}
        disableCloseOnSelect
        renderTags={() => null}
        classes={{ paper: dropdownClasses.paper }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={selecteds.length ? "" : i18n.t("tickets.search.filterUsers")}
            InputProps={{
              ...params.InputProps,
              startAdornment: summaryText ? (
                <span style={{
                  marginLeft: 6,
                  marginRight: 6,
                  fontSize: 13,
                  fontWeight: 600,
                  color: isDark ? "#e9edef" : "#0f172a",
                }}>{summaryText}</span>
              ) : null,
            }}
          />
        )}
      />
    </Box>
  );
}
